import * as DG from 'datagrok-api/dg';
import wu from 'wu';
import { ALPHABET, getAlphabet, NOTATION, TAGS } from './macromolecule';
import { StringListSeqSplitted } from './macromolecule/utils';
import { PolymerTypes } from '../helm/consts';
import { GapOriginals } from './macromolecule/consts';
export function generateManySequences() {
    const columns = [];
    columns.push(DG.Column.fromList('string', 'MSA', new Array(10 ** 6).fill('meI/hHis/Aca/N/T/dE/Thr_PO3H2/Aca/D-Tyr_Et/Tyr_ab-dehydroMe/dV/E/N/D-Orn/D-aThr//Phe_4Me')));
    columns.push(DG.Column.fromList(DG.COLUMN_TYPE.FLOAT, 'Activity', new Array(10 ** 6).fill(5.30751)));
    return columns;
}
/** Generates the column 'MSA' with sequences length of order 10^5 and the 'Activity' float column. */
export function generateLongSequence(length = 10 ** 4) {
    const longSequence = `meI/hHis/Aca/N//dE/Thr_PO3H2/Aca/D-Tyr_Et/Tyr_ab-dehydroMe`.repeat(Math.ceil(length / 10)).slice(0, -1);
    const msaCol = DG.Column.fromList(DG.COLUMN_TYPE.STRING, 'MSA', new Array(10 ** 2).fill(longSequence));
    msaCol.semType = DG.SEMTYPE.MACROMOLECULE;
    msaCol.meta.units = NOTATION.SEPARATOR;
    msaCol.setTag(TAGS.separator, '/');
    msaCol.setTag(TAGS.alphabet, ALPHABET.UN);
    msaCol.setTag(TAGS.alphabetIsMultichar, 'true');
    const columns = [];
    columns.push(msaCol);
    columns.push(DG.Column.fromList(DG.COLUMN_TYPE.FLOAT, 'Activity', new Array(10 ** 2).fill(7.30751)));
    return columns;
}
export function generateLongSequence2(seqHelper, notation = NOTATION.SEPARATOR, alphabet = ALPHABET.PT, separator = (notation === NOTATION.SEPARATOR ? '-' : undefined), monomerLib = undefined, colName = 'seq', rowCount = 100, seqLength = 10 ** 6) {
    const alphabetSet = alphabet === ALPHABET.UN ?
        monomerLib?.getMonomerSymbolsByType(PolymerTypes.PEPTIDE) ?? [] : Array.from(getAlphabet(alphabet));
    const alphabetSize = alphabetSet.length;
    const col = DG.Column.fromType(DG.COLUMN_TYPE.STRING, colName, rowCount);
    col.semType = DG.SEMTYPE.MACROMOLECULE;
    col.meta.units = notation;
    col.setTag(TAGS.alphabet, alphabet);
    if (notation == NOTATION.SEPARATOR)
        col.setTag(TAGS.separator, separator);
    const sh = seqHelper.getSeqHandler(col);
    for (let rowI = 0; rowI < rowCount; rowI++) {
        const seqMList = wu.count(0).take(seqLength)
            .map((i) => { return alphabetSet[Math.floor(Math.random() * alphabetSize)]; })
            .toArray();
        const seq = sh.joiner(new StringListSeqSplitted(seqMList, GapOriginals[notation]));
        col.set(rowI, seq);
    }
    return col;
}
//# sourceMappingURL=generator.js.map